import Intercom from './Adapters/IntercomAdapter';
import Hubspot from './Adapters/HubspotAdapter';
import FacebookPixel from './Adapters/FacebookPixelAdapter';
import FacebookConversions from './Adapters/FacebookConversionsAdapter';
import PostHog from './Adapters/PostHogAdapter';

/**
 * Class for handling all Analytics tracking and identifying
 */
class Analytics {
  /**
   * Track events on all our platforms
   * @param {String} title - Description of the event
   * @param {Object} event - Data to track
   */
  static track(title, event) {
    const eventProperties = {
      ...event,
      platform: 'web',
      sent_from: 'client',
      page_location: window.location.href,
    };

    Intercom.track(title, eventProperties);
    Hubspot.track(title, eventProperties);
    FacebookPixel.track(title, eventProperties);
    FacebookConversions.track(title, eventProperties);
    PostHog.track(title, eventProperties);
  }

  /**
   * Identify a user
   */
  static identify(user = {}, company = {}) {
    const userProperties = {
      ...user,
      user_id: user.uid,
    };
    const companyProperties = {
      ...company,
      company_id: company.cid,
    };

    Intercom.identify(userProperties, companyProperties);
    Hubspot.identify(userProperties);
    FacebookPixel.identify(userProperties);
    FacebookConversions.identify(userProperties);
    PostHog.identify(userProperties, companyProperties);
  }
}

export default Analytics;
